module.exports = __webpack_public_path__ + "img/Presta1.662c2dd7.png";